<template>
    <div class="header-payment">
        <div class="card-icon" :style="{ backgroundColor: color }">
            <ui-bill-icon />
        </div>
        <h2 class="title">{{ title }}</h2>
    </div>
</template>

<script>

export default {
    name: 'section-title',
    props: {
        title: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: '#0091ff',
            required: false
        }
    }
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>